export default __webpack_public_path__ + "images/loggedout/home/logo-4de182c84f446964a4d64efdbee1e8bf.png";